import React, { useEffect } from 'react';
import { useAppContext } from '../context/appContext';
import Loading from './Loading';
import Product from '../components/Product';
import Wrapper from '../assets/wrappers/JobsContainer';
import PageBtnContainer from './PageBtnContainer';

const ProductsContainer = () => {
  const {
    getProducts,
    products,
    isLoading,
    page,
    totalProducts,
    search,
    searchStatus,
    searchType,
    sort,
    category,
    numOfPages,
  } = useAppContext();

  useEffect(() => {
    getProducts();
    // eslint-disable-next-line
  }, [page, search, searchStatus, searchType, sort, category]);

  if (isLoading) {
    return <Loading center />;
  }

  if (products.length === 0) {
    return (
      <Wrapper>
        <h2>No products to display...</h2>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <h5>
        {totalProducts} product{products.length > 1 && 's'}
      </h5>
      <div className='jobs'>
        {products.map((product) => {
          return <Product key={product._id} {...product} />;
        })}
      </div>
      {/* pagination buttons */}
      {numOfPages > 1 && <PageBtnContainer />}
    </Wrapper>
  );
};

export default ProductsContainer;
